import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

import ArmpBusRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - Bus.svg?react';
import ArmpClockRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - Clock.svg?react';
import ArmpHouseRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - House.svg?react';
import ArmpLocationPinRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - Location Pin.svg?react';
import ArmpLocationSchedulerRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - Location Scheduler.svg?react';
import ArmpWarningRaw from '/src/assets/armp-icons/ARMP Branded UI Icons - Warning.svg?react';

import Ferry from '/src/assets/ferry.svg?react';
import Walk from '/src/assets/walk.svg?react';

function ArmpIcon({
  Icon,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { Icon: React.ComponentType<SVGProps<SVGSVGElement>> }) {
  return (
    <Icon
      className={cn("size-4", className)}
      {...props}
    />
  )
}

function ArmpBus({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpBusRaw} className={className} {...props} />
}

function ArmpClock({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpClockRaw} className={className} {...props} />
}

function ArmpHouse({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpHouseRaw} className={className} {...props} />
}

function ArmpLocationPin({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpLocationPinRaw} className={className} {...props} />
}

function ArmpLocationScheduler({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpLocationSchedulerRaw} className={className} {...props} />
}

function ArmpWarning({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <ArmpIcon Icon={ArmpWarningRaw} className={className} {...props} />
}

export {
  ArmpBus,
  ArmpClock,
  ArmpHouse,
  ArmpLocationPin,
  ArmpLocationScheduler,
  ArmpWarning,
  Ferry,
  Walk,
}
